export enum PaymentMethod {
    CHEQUE = 3,
    CASH = 2,
    LINK = 4
}
